import { NewLearningActivityPage } from '@hendrx/core/learningActivity/pages/NewLearningActivityPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/studio/learning-activity/new')({
  component: NewLearningActivityWrapper
});

function NewLearningActivityWrapper() {
  return <NewLearningActivityPage />;
}
